import { formatNounOverrideText } from "./formatNounOverride";

export type NounOverrideText = string | null | undefined;

export type NounOverrideFields =
  | {
      readonly singular?: NounOverrideText;
      readonly plural?: NounOverrideText;
    }
  | null
  | undefined;

export const getNounOverride = (
  overrideText: NounOverrideText,
  defaultText: string,
  lowercaseFirstLetter = false
) => {
  const text = overrideText?.trim() || defaultText;

  return formatNounOverrideText(lowercaseFirstLetter, text);
};
